export function handleError(e) {
  if (window.document.documentMode) {
    console.error("Please upgrade to an up-to-date browser! This website will not function properly.");
    return;
  }

  e.url = location.href;
  e.userAgent = window.navigator.userAgent;

  if (e.message === "") return;
  if (e.message === "Script error.") return;

  let jsonString = JSON.stringify(e, ["message", "arguments", "type", "name", "filename", "lineno", "url", "userAgent"]);
  if (jsonString === undefined) return;

  console.error("Something went wrong. Please try again later or contact HeBlad.");
  try {
    fetch("/error404?type=js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: jsonString
    }).then(res => res.json()).then((response) => {
      // console.log(response);
    });
  }
  catch (e) {

  }

}